import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { searchIsDisabledText, useDisableSearch } from '../../../../../../views/root/context/use-is-maintenance-mode';
import { HeaderSearch } from '../../../../../upright/model/output/search/header-search';
import { handleSearchOptionChange } from '../../handle-option-change';

interface Props {
  close: () => void;
}

export function SearchBlock(props: Props) {
  const disabled = useDisableSearch();
  const navigate = useNavigate();
  return (
    <Root data-testid={E2eTestElementId.MOBILE_SEARCH}>
      {!disabled ? (
        <HeaderSearch
          theme="dark" // Todo RN: properly support light theme in HeaderSearch. React Select provides a theme object, too.
          hideFilters={true}
          onChange={value => {
            handleSearchOptionChange(navigate, value);
            props.close();
          }}
        />
      ) : (
        <>{searchIsDisabledText}</>
      )}
    </Root>
  );
}

const Root = styled.div``;
